import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    content: {
        minWidth: 400,
    },
    justificationField: {
        marginTop: theme.spacing(2),
        width: '100%',
    },
}));

const ModalConfirmDeletePayment = (props) => {
    const { open, setOpen, onConfirm, paymentData } = props;
    const [justification, setJustification] = useState('');
    const classes = useStyles();

    const handleClose = () => {
        setOpen(false);
        setJustification('');
    };

    const handleConfirm = () => {
        if (justification.trim()) {
            onConfirm(justification);
            handleClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="confirm-delete-dialog"
        >
            <DialogTitle id="confirm-delete-dialog">
                Confirmar Eliminación de Pago
            </DialogTitle>
            <DialogContent className={classes.content}>
                <div>
                    ¿Está seguro que desea eliminar el siguiente pago?
                </div>
                {paymentData && (
                    <div style={{ marginTop: 16 }}>
                        <strong>Concepto:</strong> {paymentData.concept}<br />
                        <strong>Monto:</strong> ${paymentData.total}<br />
                        <strong>Fecha:</strong> {paymentData.friendlyDate ? new Date(paymentData.friendlyDate).toLocaleDateString('es-MX') : 'Fecha no disponible'}
                    </div>
                )}
                <TextField
                    className={classes.justificationField}
                    label="Justificación *"
                    multiline
                    rows={3}
                    variant="outlined"
                    value={justification}
                    onChange={(e) => setJustification(e.target.value)}
                    helperText="Por favor proporcione una justificación para eliminar este pago"
                    required
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={handleClose}
                    color="secondary"
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    onClick={handleConfirm}
                    color="primary"
                    disabled={!justification.trim()}
                >
                    Confirmar Eliminación
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalConfirmDeletePayment;